import { createSlice } from '@reduxjs/toolkit';
import { GetProjectsParams } from '@src/api/projects/projects';
import { MetaDto } from '@src/types/meta';
import { GuideState } from '@src/types/product';
import { getGuideList, getPicSuggestionList } from './guideListThunk';

export interface GuideListState {
  loading: boolean;
  picSearch: {
    isSearching: boolean;
    searchTerm: string;
    suggestions: { adminUserId: number; name: string }[];
    name: string;
  };
  guideList: GuideState[];
  meta: MetaDto;
  params: GetProjectsParams;
}

const initialState: GuideListState = {
  loading: false,
  picSearch: {
    isSearching: false,
    searchTerm: '',
    suggestions: [],
    name: '',
  },
  guideList: [],
  meta: { totalItems: 1, totalPages: 1 },
  params: { page: 1, limit: 25 },
};

const guideListSlice = createSlice({
  name: 'guide',
  initialState,
  reducers: {
    onChangePageNum: (state, { payload }) => {
      state.params.page = payload;
    },
    onChangePicSearchValue: (state, { payload }) => {
      state.picSearch = { ...state.picSearch, ...payload };
    },
    onChangeFilterData: (state, { payload }) => {
      state.params.filter = { ...state.params.filter, ...payload };
    },
    onChangeSearchOption: (state, { payload }) => {
      state.params.searchBy = payload;
    },
    onChangeSearchData: (state, { payload }) => {
      state.params.search = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGuideList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGuideList.fulfilled, (state, { payload }) => {
        const {
          data,
          meta: { totalItems, totalPages, filter, currentPage, itemsPerPage },
        } = payload;

        state.meta = { totalItems, totalPages, itemsPerPage, currentPage };
        state.params = { ...state.params, filter, page: currentPage };
        state.guideList = data.map((project) => {
          const {
            id,
            name,
            type,
            status,
            company,
            updatedAt,
            adminUser,
            user,
          } = project;

          return {
            id,
            projectName: name,
            projectType: type,
            status,
            companyName: company.name,
            companyId: company.id,
            updatedAt,
            pic: adminUser?.name,
            user: user?.name,
            userId: user?.id,
            mainAdminUser: project.mainAdminUser,
          };
        });
        state.loading = false;
      })
      .addCase(getGuideList.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getPicSuggestionList.pending, (state) => {
        state.picSearch.isSearching = true;
      })
      .addCase(getPicSuggestionList.fulfilled, (state, { payload }) => {
        state.picSearch.suggestions = payload.map((data) => ({
          adminUserId: data.id,
          name: data.name,
        }));
        state.picSearch.isSearching = false;
      });
  },
});

export const {
  onChangePageNum,
  onChangePicSearchValue,
  onChangeFilterData,
  onChangeSearchOption,
  onChangeSearchData,
} = guideListSlice.actions;
export default guideListSlice.reducer;
